import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import {
  checkUserAccess,
  formatTo12HourTime,
  handleStatus,
} from "../../../utility/CommonFunctions";
import { toast } from "react-toastify";
import moment from "moment";
import { useSelector } from "react-redux";
import Logs from "../../Logs/Logs";

export default function AdminOdRequestDetail() {
  const userDetails = useSelector((state) => state.root.userDetails);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const { id } = useParams();
  const [odRequestData, setOdRequestData] = useState({});
  const [refreshLogs, setRefreshLogs] = useState(false);
  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    getOdRequests();
  }, []);

  const getOdRequests = () => {
    let options = {
      method: "GET",
    };
    const Url = apiUrl.get_od_details + `?odRequestId=${id}`;
    setIsLoading(true);
    callApi(Url, options).then((res) => {
      setIsLoading(false);
      if (res?.status === true) {
        setOdRequestData(res?.data);
      } else {
        toast.error(res?.message);
      }
    });
  };

  const HandleApprove_Reject = (type) => {
    let newStatus;
    if (type == "approve") {
      newStatus = 1;
    } else if (type == "reject") {
      newStatus = 2;
    }
    const submitData = {
      type: "odRequest",
      id: odRequestData?.id,
      status: newStatus,
    };
    // console.log("submitData>>>>", submitData);
    const options = {
      method: "POST",
      data: submitData,
    };
    let API = apiUrl?.user_status_update;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        toast.success(response?.message);
        getOdRequests();
        setRefreshLogs(true);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const uniqueSiteTypes = [
    ...new Set(
      odRequestData?.user?.usersites
        ?.map((item) => item.site.type)
        .filter(Boolean)
    ),
  ];

  return (
    <>
      <>
        <div className="content container-fluid">
          <div className="content-head mb-5 d-flex align-items-start justify-content-between">
            <div className="d-flex align-items-center justify-content-start gap-4">
              <button className="btn back-arrow" onClick={handleBack}>
                <BackArrowIcon />
              </button>
              <h1 className="mb-0">O.D. Detail</h1>
            </div>
          </div>
          <div className="card manage-user-list">
            <div className="card-body">
              <ul
                className={
                  isLoading
                    ? "row list-unstyled mt-4 loading-skeleton"
                    : "row list-unstyled mt-4"
                }
              >
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Emp. Code :</span>
                    {odRequestData?.user?.employeeCode || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Emp. Name :</span>
                    {odRequestData?.user?.name || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Status :</span>
                    {handleStatus(odRequestData?.status) || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Department :
                    </span>
                    {odRequestData?.user?.department?.name || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Designation :
                    </span>
                    {odRequestData?.user?.designation?.name || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      {odRequestData?.user?.type == 1 && " Office :"}
                      {odRequestData?.user?.type == 0 && " Site :"}
                    </span>
                    {odRequestData?.user?.type == 1
                      ? odRequestData?.user?.site?.name
                      : odRequestData?.user?.type == 0
                      ? odRequestData?.user?.usersites?.[0]?.site?.name
                      : "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Site Type :</span>
                    {uniqueSiteTypes.join(", ")}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Mode of Communication :
                    </span>
                    {odRequestData?.communicationMode || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Client Name :
                    </span>
                    {odRequestData?.clientName || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Contact Person :
                    </span>
                    {odRequestData?.contactPersonName || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Contact Number :
                    </span>
                    {odRequestData?.phoneNumber || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Location :</span>
                    {odRequestData?.locationName || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Start Date :
                    </span>
                    {(odRequestData?.startDate &&
                      moment(odRequestData?.startDate).format("DD-MM-YYYY")) ||
                      "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">End Date :</span>
                    {(odRequestData?.endDate &&
                      moment(odRequestData?.endDate).format("DD-MM-YYYY")) ||
                      "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Reason :</span>
                    {odRequestData?.reason || "--"}
                  </p>
                </li>

                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Remark :</span>
                    {odRequestData?.remark || "--"}
                  </p>
                </li>
                {/* {odRequestData?.user?.type == 0 ? (
                  ""
                ) : (
                  <li className="col-12 col-md-6 col-lg-4">
                    <p>
                      <span className="text-muted fs-5 d-block">
                        Assigned Sites :
                      </span>
                      <ul className="list-unstyled">
                        {odRequestData?.user?.usersites?.length > 0
                          ? odRequestData?.user?.usersites?.map(
                              (userSite, index) => (
                                <li key={userSite.id || index}>
                                  {userSite.site?.name || "--"}
                                </li>
                              )
                            )
                          : "-"}
                      </ul>
                    </p>
                  </li>
                )} */}
              </ul>
            </div>
            {((checkUserAccess(userDetails).isUserAccess &&
              location?.state?.type === "request" &&
              userDetails?.type !== 2) ||
              location?.state?.type === "teamRequest") && (
              <div className="card-body d-flex justify-content-end">
                <div className="col-12 col-md-6 col-lg-4 ">
                  <span className="d-flex align-items-center gap-3 justify-content-end">
                    <>
                      <button
                        className="btn btn-success "
                        onClick={() => HandleApprove_Reject("approve")}
                        disabled={odRequestData?.status == 1}
                      >
                        Approve
                      </button>
                      <button
                        className="btn btn-danger px-4"
                        onClick={() => HandleApprove_Reject("reject")}
                        disabled={odRequestData?.status == 2}
                      >
                        Reject
                      </button>
                    </>
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
        <Logs
          type={"odRequest"}
          id={id}
          refreshLogs={refreshLogs}
          setRefreshLogs={setRefreshLogs}
        />
      </>
    </>
  );
}
